import vuexStoreFactory from "@/_util/vuex-store-factory"
let factory = new vuexStoreFactory();

import config from "@/_store/modules/app-settings-config"

export default factory.generateVuexModule(config);
